// Shared helper to open the contact form pre-filled with an enquiry
// about a specific car. Uses a window CustomEvent that ContactSection
// listens for — this keeps the flow decoupled from prop drilling.

export const ENQUIRY_EVENT = "prefill-contact";

export function askAboutCar(car) {
    if (!car) return;
    const subject = `Enquiry: ${car.year} ${car.make} ${car.model}`;
    const message = `Hi, I'm interested in your ${car.year} ${car.make} ${car.model} (ID: ${car.id}). Please share more details on parts availability and price.`;
    window.dispatchEvent(
        new CustomEvent(ENQUIRY_EVENT, { detail: { subject, message } })
    );
    // Wait a tick so ContactSection state updates before scroll settles
    setTimeout(() => {
        const el = document.getElementById("contact");
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
        setTimeout(() => {
            const ta = document.querySelector('[data-testid="contact-message-input"]');
            if (ta) ta.focus();
        }, 500);
    }, 50);
}
